module.exports = "<div gw-pl-stepper-ctrl\n     display-value=\"displayValue()\"\n     have-prev-value=\"couldGoPrev()\"\n     have-next-value=\"couldGoNext()\"\n     select-prev-value=\"goBack()\"\n     select-next-value=\"goForward()\"></div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/inputs/templates/stepper-select.html
// module id = 775
// module chunks = 0